import ListAltIcon from '@material-ui/icons/ShortText';

const ArcheticturalReviewerSubitem = () => {
  const links = {
    subheader: 'Architectural Reviewer Submenu',
    owner: 'architectural-reviewer',
    items: [
      {
        title: 'Processed Permits',
        icon: ListAltIcon,
        href: '/architectural-reviewer/reviewed/request/permit/approved-list',
        enabled: true
      },

      {
        title: 'Processed Permits For Occupancy',
        icon: ListAltIcon,
        href:
          '/architectural-reviewer/reviewed/request/occupancy/permit/approved-list',
        enabled: true
      }
    ]
  };

  return links;
};

export default ArcheticturalReviewerSubitem;
